export class GalleryItem {
    constructor(optionalOptions = {}) {
        this._gridItems = document.querySelectorAll('.gallery-list--grid:not(.gallery-full) .gallery-list--item.gallery-list--show');

        if (!this._gridItems) {
            this.destructor();
            return true;
        }

        this._gridItems.forEach((item) => {
            item.addEventListener("click", () => {
                if (!item.parentNode.classList.contains('gallery-full')) {
                    item.parentNode.classList.add("gallery-full");
                }
            })
        })
    }

    destructor() {
        this._gridItems = null;
    }
}

export default new GalleryItem();
